module.exports = __webpack_public_path__ + "img/banner-two11.815c5f9d.png";